export default {
  idNumber: 'Saudi ID/Iqama Number',
  dob: 'Date of Birth',
  terms:
    'By clicking Next, you grant Tameeni company the right to inquire from any related agency about your data or any other data',
  submit: 'Buy Now',
  processing: 'Processing your application...',
  schemeTitle: "Get the discount if you're working for any of these Entities.",
  schemeSubTitle: 'Select your entity to apply its benefits:',
  businessEmail: 'Business Email',
  nationalIdValidationLabel:
    'Please click verify to enjoy scheme benefits by validating your National ID / Iqama Number',
  nationalId: 'National ID/Iqama Number',
  entityCode: 'Entity Name',
  entityPromoCode: 'Entity Promo Code',
  apply: 'Apply',
  resend: 'Resend',
  schemeVerificationFailed: 'A valid scheme entity was not found',
  schemeVerificationNationalIdFailed: 'We could not verify your entity',
  emailOTPVerificationFailed:
    'Incorrect email verification code, please check your email and try again',
  otpRequired: 'OTP is required',
  sendVerification: 'Send Verification',
  verificationCode: 'Verification Code',
  verify: 'Verify',
  resendCode: 'You didn’t get the code? Resend a new code. [{{timeLeft}}]',
  schemeVerificationSuccess:
    'You got the discount successfully, complete your purchase to apply it.',
  entityCodeRequired: 'Entity code is required',
  optionRequired: 'Option is required',
  emailFormatError: 'Please enter a valid email address',
  emailRequired: 'Email is required',
  promoCodeRequired: 'Please provide an entity code.',
  idNumberRequired: 'National ID/Iqama Number is required',
  idNumberInvalid:
    'The ID entered is invalid, kindly check the input and try again',
  dateOfBirthRequired: 'Date of birth is required',
  ageRestriction: 'You must be between {{min}} and {{max}} years old',
  identityMismatch:
    'Please note that same customer identity for the policy holder must be the same logged-in customer identity',
  anatIdentityMismatch:
    'Please note that the logged-in account hold an identity different than the identity received',
} as const
